import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import DefaultContainer from '../../../../components/DefaultContainer/DefaultContainer';
import { PostsList } from '../PostsList/PostsList';
import { AddPost } from '../AddPost/AddPost';
import Icon from '../../../../components/Icon/Icon';

import { getForumTopicById } from '../../../../service/forumTopic';
import { getClub } from '../../../../service/clubs';
import { getClubForum } from '../../../../service/forum';

import { useUserStore } from '../../../../store/useUser';

import { main_color } from '../../../../styles/_variables';
import styles from './ForumTopic.module.scss';

import useHeader from '../../../../hooks/useHeader';
import { getClubUser } from '../../../../service/clubUser';

const ForumTopic: React.FC = () => {
  const navigate = useNavigate();

  const { id, name: clubName, forumTopicId: ftId, forumId: fId } = useParams();

  const clubId = Number(id);
  const forumTopicId = Number(ftId);
  const forumId = Number(fId);
  const userId = useUserStore(state => state.id);

  const { data:clubUser, isFetching: isFetchingClubUser } = useQuery(
    ['clubUser', clubId],
    () => getClubUser(userId, clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data:forumTopic, refetch, isFetching: isFetchingForumTopic } = useQuery(
    ['forum', 'topic', forumTopicId],
    () => getForumTopicById(forumTopicId, forumId, clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data:forum, isFetching: isFetchingClubForum } = useQuery(
    ['forum', 'club', clubId],
    () => getClubForum(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data:club, isFetching: isFetchingClub } = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const isMember = clubUser?.wasAccepted === 1;

  useHeader({ header: clubName, subheader: 'Tópico do Fórum' });

  const isFetching = isFetchingForumTopic || isFetchingClub || isFetchingClubForum || isFetchingClubUser;

  if (isFetching) return null;

  if (!userId) return <DefaultContainer>Você precisa fazer login</DefaultContainer>
  
  if((!isMember) || (!forumTopic.wasApproved)) return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.clubHeader}
          onClick={() => navigate(`/club/${club.id}/${club.name}`)}
        >
          <Icon className={styles.icon} icon='group' color={main_color} />
          <span className={styles.name}>{club.name}</span>
        </div>
        <div className={styles.forumHeader}
          onClick={() => navigate(`/club/${club.id}/${club.name}/forum`)}
        >
          <Icon className={styles.icon} icon='forum' color={main_color} />
          <span className={styles.name}>{forum.title}</span>
        </div>
        {forumTopic &&        
          <div className={styles.topicHeader}>
            <Icon className={styles.icon} icon='topic' color={main_color} />
            <span className={styles.name}>{forumTopic.title}</span>
          </div>
        }
      </div>
      <div className={styles.clubsContainer}>
        {Object.keys(forumTopic).length !== 0 &&
          <div>
            <PostsList forumId={forumId} forumTopicId={forumTopic.id} clubId={clubId} />
            <AddPost forumId={forumId} forumTopicId={forumTopic.id} clubId={clubId} userId={userId} refetchData={refetch} />
          </div>
        }
        {Object.keys(forumTopic).length === 0 &&
          <div>Esse tópico de fórum não existe.</div>
        }

      </div>
    </div>
  )
}

export default ForumTopic;